import React from "react";
import "antd/dist/antd.min.css";
import axios from './axios';
import {Table, Button, Input, Space, Tag} from "antd";
import { SearchOutlined, LockFilled } from '@ant-design/icons';
import { useState, useCallback, useEffect, useRef} from "react";

import StockPerformance from "./StockPerformance";

import {NFLteamFilters, NFLposFilters, positionMap, NFLplayoffTeamFilters} from './CONSTANTS';

import { useMediaQuery } from 'react-responsive';

const NFLTable = (props) => {


  const [isErr,setIsErr] = useState(false);
  const [loading,setLoading] = useState(true);
  const [marketData,setMarketData] = useState([]);
  const [chartView, setChartView] = useState(false);
  const [chartEquity,setChartEquity] = useState(-1);
  const [chartName,setChartName] = useState("");
  const [currentFilters,setCurrentFilters] = useState({});

  //console.log(props);


  //const isTabletOrMobile = useMediaQuery({maxWidth:640});
  const isLarge = useMediaQuery({minWidth:900});
  //const isMobile = useMediaQuery({maxWidth:500});
  const isXSmall = useMediaQuery({maxWidth:575});

  const [playoffTeams,setPlayoffTeams] = useState([]);

  const [tablePagination,setTablePagination] = useState({current:1, pageSize:50});

  const teamSorter = (a, b) => {
    if (a.text<b.text){
      return -1;
    }
    else {
      return 1;
    }
  }


  const nameSearchProps = {
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Search Name`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Search
          </Button>
          <Button
            onClick={() => handleReset(clearFilters,setSelectedKeys,confirm)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            Close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? '#1677ff' : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record['name'].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    }
  };


  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sortDirections: ['descend','ascend'],
      width: isLarge ? 'auto' :  '15%', 
      sorter:  (a, b) => {
        if (a.name>b.name){
          return -1;
        }
        else {
          return 1;
        }
      },
      render: (text,record) => (
        !record.purchasable ? <span> {text}  <LockFilled /> </span> : <span>{text}</span>
      ),
      ...nameSearchProps
    },
    {
      title: isLarge ? "Position" : "Pos",
      dataIndex: "position",
      key: "position",
      //responsive: ['sm'],
      width: isLarge ? 'auto' :  '10%',
      sortDirections: ['descend','ascend'],
      sorter:  isLarge ? (a, b) => {
        if (a.position>b.position){
          return 1;
        }
        else {
          return -1;
        }
      } : null,
      filters: NFLposFilters,
      defaultFilteredValue : currentFilters.position,
      onFilter: (value, record) => record.position===value
    },
    {
      title: !isXSmall ? "Team" : "Tm",
      dataIndex: isLarge ? "team" : "teamabbrev",
      key: "team",
      sortDirections: ['descend','ascend'],
      width: isLarge ? 'auto' :  '15%',
      sorter: isLarge ? (a, b) => {
        if (a.team>b.team){
          return -1;
        }
        else {
          return 1;
        }
      } : null,
      filters: props.type==="Playoffs" ? playoffTeams.sort(teamSorter) : NFLteamFilters,
      defaultFilteredValue : currentFilters.team,
      onFilter: (value, record) => record.team===value
    },
    {
      title: "",
      responsive: ['md'],
      render : (record) => (
        <Button onClick={(e) => {goToStockChart(e,record)}}>See Chart</Button>
      ),
      hidden: props.transact===2
    },
    {
      title: "Price",
      dataIndex: "price",
      key: "price",
      width: isLarge ? 'auto' :  '15%',
      defaultSortOrder: 'descend',
      sortDirections: ['descend','ascend'],
      sorter:  (a, b) => a.price - b.price,
      hidden: props.transact===2
    },
    {
      title: "Weekly Change",
      dataIndex: "change",
      key: "change",
      responsive: props.transact>0 ? ['sm'] : null,
      sortDirections: ['descend','ascend'],
      sorter:  (a, b) => a.change - b.change,
      render: (text,record) => (
        record.change ? (record.change>0 ? <Tag color='green'>{text}%</Tag> : (record.change<0 ? <Tag color='red'>{text}%</Tag> : <Tag>{text}%</Tag>)) : <span>-</span>

      ),
      hidden: props.hist || props.transact===2
    },
    {
      title: "YTD Change",
      dataIndex: "YTDchange",
      key: "YTDchange",
      responsive: ['sm'], //small appears at 575px
      sortDirections: ['descend','ascend'],
      sorter:  (a, b) => a.YTDchange - b.YTDchange,
      render : (text,record) => (
        record.YTDchange ? (record.YTDchange>0 ? <Tag color='green'>{text}%</Tag> : (record.YTDchange<0 ? <Tag color='red'>{text}%</Tag> : <Tag>{text}%</Tag>)) : <span>-</span>

      ),
      hidden: props.transact===2
    },
    {
      title: "Dividend",
      dataIndex: "dividend",
      key: "dividend",
      sortDirections: ['descend','ascend'],
      sorter:  (a, b) => a.dividend - b.dividend,
      responsive: ['sm'],
      hidden: props.hist || props.transact===2
    },
    {
      title: "Proj. Earnings",
      dataIndex: "growth",
      key: "growth",
      sortDirections: ['descend','ascend'],
      sorter:  (a, b) => a.growth - b.growth,
      responsive: ['sm'],
      hidden: props.hist || props.transact===2
    },
    { //buy columns
      title: props.transact===1 ? "Buy Shares" : "Add",
      dataIndex: "key",
      key: "key",
      responsive: ['sm'],
      render : (text,record) => (
        record.purchasable ? <Button onClick={(e) => {props.purchaseCallback(e,record)}} >{props.transact===1 ? "Buy Shares" : "Add"}</Button> : <LockFilled />
      ),
      hidden: props.transact===0
    },
    { //buycolumn mobile
      title: props.transact===1 ? "Buy" : "Add",
      dataIndex: "key",
      key: "key",
      responsive: ['xs'],
      render : (text,record) => (
        record.purchasable ? <Button onClick={(e) => {props.purchaseCallback(e,record)}} >{props.transact===1 ? "Buy" : "Add"}</Button> : <LockFilled />
      ),
      hidden: props.transact===0
    }

  ].filter(item=>!item.hidden);


  const [tableColumns,setTableColumns] = useState(columns);

  const udpateTableColumns = () => {


    setTableColumns(columns);
  }

  useEffect(() => {
    if (!chartView) {
      // When switching back to the table, apply the saved filters
      udpateTableColumns();
    }
  }, [chartView, currentFilters]);  // eslint-disable-line react-hooks/exhaustive-deps


  const fetchData =  useCallback(async() => {

    var data = [];
    setMarketData([]);
    try {
      console.log("get nfl market response");
      var url;
      console.log(props.type);
      if (props.type==="Playoffs") {
        console.log("here in playoffs");
        url = "NFLPlayoffmarket";
      }
      else {
        url = "NFLmarket";
      }
      if(props.hist){
        url = url + "History";
      }
      console.log(url);

      const res = await axios.get('/getmarket/'+ url,{
        params: {
          timeframe: props.timeframe
        }
      });
      console.log(res)
      console.log(res.data); //debugger
      const playoffFilters = [];
      for (let i=0; i<res.data.length; ++i){
        var obj;
        var record = res.data[i];
        var YTDchange;
        var change;
        //console.log(record);
        if (record?.prevprice){
          //console.log(record.prevprice)
          change = (100*(Number(record.price)-Number(record.prevprice))/Number(record.prevprice)).toFixed(2);
        }
        else {
          change = null;
        }
        if (record?.origprice){
          YTDchange = (100*(record.price-record.origprice)/Number(record.origprice)).toFixed(2);
        }
        else {
          YTDchange = null;
        }
       // console.log(change)
        if (record?.player_id){
          obj = {
            name: record.fname + " " + record.lname,
            position: positionMap[record.position_id],
            team: record.city + " " + record.nickname,
            teamabbrev: record.abbrev,
            rookie: record.rookie,
            price: record.price,
            dividend: record.dividend,
            equity_id: record.equity_id,
            ent_id: record.player_id,
            key: record.equity_id,
            team_id: record.team_id,
            restricted: record.restricted || (record.halted & 1 !==0),
            halted: ((record.halted & 1)===0 && !record.restricted && record.halted>1),
            change: change,
            YTDchange: YTDchange,
            growth: (record.price - record.dividend).toFixed(2)
          }
          //stock is purchasable if its not restricted AND (its roster based or halting does not prevent buying)
          obj.purchasable = !record.restricted && (props.transact===2 || ((record.halted&1)===0 && (record.halted&2)===0))
        }
        else {
          //console.log(record);
          obj = {
            name: record.city + " " + record.nickname,
            position: "TEAM",
            team: record.city + " " + record.nickname,
            teamabbrev: record.abbrev,
            price: record.price,
            dividend: record.dividend,
            equity_id: record.equity_id,
            ent_id: record.team_id,
            key: record.equity_id,
            team_id: record.team_id,
            restricted: record.restricted,
            halted: false,
            purchasable: !record.restricted,
            change: change,
            YTDchange: YTDchange,
            growth: (record.price - record.dividend).toFixed(2)
          }
          if (props.type==="Playoffs" && props.hist){
            const filter = {
              text: obj.team,
              value: obj.team //TODO: change to id and filter on ID in future
            }
            playoffFilters.push(filter)
          }


        }
        if (obj.rookie){
          obj.name = obj.name + "(R)";
        }
        if (obj.halted && props.transact===1){
          obj.name = obj.name + "*";
        }
        data.push(obj)
      }
      //data.sort()

      console.log(data);
      setMarketData(data);
      if (props.hist){
        console.log(playoffFilters);
        setPlayoffTeams(playoffFilters);
      }
      else {
        setPlayoffTeams(NFLplayoffTeamFilters);
      }

      setLoading(false);

    
    }
    catch (err) {
      console.log(err);
      setIsErr(true);
      setLoading(false);
    }
  },[props.type,props.hist,props.transact,props.timeframe]);

  useEffect( () => {
    console.log("here in nfl table use effect");
    console.log(props.transact)

    setLoading(true);
    fetchData();
    udpateTableColumns();
  }, [fetchData,props.transact,props.type]); // eslint-disable-line react-hooks/exhaustive-deps


  useEffect( () => {
    console.log("updating columns 2")
    udpateTableColumns();
  }, [isXSmall,isLarge,playoffTeams]);  // eslint-disable-line react-hooks/exhaustive-deps


  const searchInput = useRef(null);
  const handleSearch = (selectedKeys, confirm) => {
    console.log("handle search");
    console.log(selectedKeys);
    confirm();
  };
  const handleReset = (clearFilters,setSelectedKeys,confirm) => {
    console.log("handle reset ")
    clearFilters();
    setSelectedKeys([]);
    confirm();
  };

  const backFunction = () => {
    setChartView(false);
    setChartEquity(-1);
    setChartName("")
    props.backFunction()
  }

  const goToStockChart = (e,record) => {
    console.log(record.ent_id);
    setChartView(true);
    setChartEquity(record.equity_id);
    setChartName(record.name)
    props.showStockPerformance(record.equity_id,record.name);
  }

  const tablePaginationRef = useRef(tablePagination);
  const filterRef = useRef(currentFilters);
  const handleTableChange = (pagination,filters,sorter,extra) => {
    console.log("handle table change");
    //console.log(pagination);
    //console.log(filters)
    console.log(sorter)
    console.log("extra")
    console.log(extra)
    setCurrentFilters(filters);
    filterRef.current = filters;
    setTablePagination(pagination);
    tablePaginationRef.current = pagination;
  }

  const expandableRows = {
    expandedRowRender: (record) => (
      <span>
        <div>
         {props.transact>0 ? <span>Weekly Change: {record.change ? (record.change>0 ? <Tag color='green'>{record.change}%</Tag> : (record.change<0 ? <Tag color='red'>{record.change}%</Tag> : <Tag>{record.change}%</Tag>)) : <span>-</span>}</span> : <span></span>}
         YTD Change: {record.YTDchange ? (record.YTDchange>0 ? <Tag color='green'>{record.YTDchange}%</Tag> : (record.YTDchange<0 ? <Tag color='red'>{record.YTDchange}%</Tag> : <Tag>{record.YTDchange}%</Tag>)) : <span>-</span>}
        </div>
        <div>
          Dividend: ${record.dividend}  Proj. Earnings: ${record.growth}
        </div>
        {/*<div>
        <Button onClick={(e) => {goToStockChart(e,record)}}>See Chart</Button>
    </div>*/}
        {<div>
          <StockPerformance  eqID={record.equity_id} name={record.name}  mobile={true} hist={props.hist}/>
        </div>}
      </span>
    ),
    rowExpandable: (record) => isXSmall
  }

    return (
      <span>
        {!chartView && <div>
          {!isErr &&
            <span><text>Some aspects of trading may be halted for players indicated with a *</text>
          <Table
            dataSource={marketData}
            columns={tableColumns}
            loading={loading}
            pagination={tablePagination}
            onChange={handleTableChange}
            expandable={isXSmall ? expandableRows: null}
            size= {isLarge ? "large" : "small"}
            style={{ zIndex:2 }}

          />
          </span>}
          {isErr &&
          <p>Server Error. Failed to get market data.</p>}
        </div>}
        {chartView && <StockPerformance backFunction={backFunction} eqID={chartEquity} name={chartName}  mobile={false} hist={props.hist}/>}
      </span>
    );

}


export default NFLTable